




































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ColorPickerInput from "@/components/game/ColorPickerInput.vue";
import PlayerTag from "@/components/game/PlayerTag.vue";
import { random } from "@/app/helpers";
import { COLORS } from "@/app/constants";

@Component({ components: { ColorPickerInput, PlayerTag } })
export default class PlayerForm extends Vue {
  @Prop() avatar?: string;
  @Prop({ required: false }) color?: string;
  @Prop() tag?: string;
  @Prop({ required: true }) onCancel!: () => void;
  @Prop({ required: true }) onSave!: (tag: string, color: string) => void;

  loading = false;
  tmpColor = this.color || random(COLORS);
  tmpTag = this.tag || "player";
  tagMax = 20;

  @Watch("color")
  onColorChanged(val: string) {
    if (val && !this.tmpColor) this.tmpColor = val;
  }
  @Watch("tag")
  onTagChanged(val: string) {
    if (val && !this.tmpTag) this.tmpTag = val;
  }

  get formattedTag(): string {
    return this.tmpTag ? this.tmpTag.toLowerCase().replace(/[^a-z-\d]/g, "") : "";
  }
  get valid(): boolean {
    return this.validTag && !!this.tmpColor && this.changed;
  }
  get validTag(): boolean {
    return !!this.formattedTag && this.formattedTag.length <= this.tagMax;
  }
  get changed(): boolean {
    const tag = this.tag;
    const color = this.color;
    return this.formattedTag !== tag || this.tmpColor !== color;
  }

  handleOnSave(e: Event) {
    e.preventDefault();
    this.loading = true;
    // TODO: update player color in game
    // TODO: load or save from localStorage
    if (this.valid) this.onSave(this.formattedTag, this.tmpColor);
    this.loading = false;
  }
}
